var elements = {
  img: 'img',
  self: 'self',
  borderBox: 'borderBox',
  imgPublicClass: 'imgPublicClass'
}
export default elements
